export const currencyFormatter = (amount, amountCurrency) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: amountCurrency ?? 'usd',
  }).format(amount);

export const currencySymbol = (amountCurrency) => {
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: amountCurrency ?? 'usd',
  }).format(0);
  const symbol = formatted.replace(/[\d.]/g, '').trim();
  return symbol;
};
